import { configureStore } from "@reduxjs/toolkit";
import applicationHomeReducer from "../pages/ApplicationHome/applicationHomeSlice";
import answerReducer from "../pages/Answer/answerSlice";
import loginReducer from "../pages/Login/loginSlice";
import applicationMethodReducer from '../pages/ApplicationMethod/applicationMethodSlice'
import applicationReducer from '../pages/Application/applicationSlice'
import personDetailReducer from '../pages/PersonDetail/personDetailSlice'
import applicationInstructionReducer from '../pages/ApplicationInstruction/applicationInstructionSlice'
import applicationFormInstructionReducer from '../pages/ApplicationFormInstruction/applicationFormInstructionSlice'
import applicationContinueReducer from '../pages/ApplicationContinue/applicationContinueSlice'
import multipleApplicationReducer from '../pages/MultipleApplication/multipleApplicationSlice'
import applicationCompletionReducer from '../pages/ApplicationCompletion/applicationCompletionSlice'
import applyNowReducer from '../pages/ApplyNow/applyNowSlice'
import applicantDetailsReducer from '../pages/ApplicantDetails/applicantDetailsSlice'
import paymentReducer from '../pages/Payment/paymentSlice'
export default configureStore({
    reducer: {
        login: loginReducer,
        answer: answerReducer,
        applicationMethod: applicationMethodReducer,
        application: applicationReducer,
        personDetail: personDetailReducer,
        applicationInstruction: applicationInstructionReducer,
        applicationFormInstruction: applicationFormInstructionReducer,
        applicationContinue: applicationContinueReducer,
        multipleApplication: multipleApplicationReducer,
        applicationCompletion: applicationCompletionReducer,
        applyNow: applyNowReducer,
        applicantDetails: applicantDetailsReducer,
        payment: paymentReducer,
        applicationHome: applicationHomeReducer,
    },
});
